export default "__VITE_ASSET__BnA4$AKG__"